import { AssignCard } from './../../data/AssignCard';
import { Component, OnInit } from '@angular/core';
import { ProfileSearchResult } from '../../data/ProfileSearchResult';
import { CardholderService } from '../../services/cardholder.service';
import { EntitlementService } from '../../services/entitlement.service';
import { CardholderDetails } from '../../data/CardholderDetails';
import { CustomerAccount } from '../../data/CustomerAccount';
import { Identity } from '../../Identity';
import { Card } from '../../data/Card';
import { NCConstants } from '../../data/NCConstants';
import { MessageService } from '../../services/message.service';
import { MerchantService } from 'src/app/services/merchant.service';

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.css']
})
export class AccountsComponent implements OnInit {
  cardholder: ProfileSearchResult;
  cardholderDetails: CardholderDetails;
  stripAccount: CustomerAccount;
  chipsAccount: CustomerAccount[];
  originalCardStatuses: string[] = [];
  originalChipStatuses: string[] = [];
  spinnerFlag = true;
  cardStatus = '';
  identity: Identity;
  isEscrow: boolean;
  customerAccount: CustomerAccount;
  customerAccounts: CustomerAccount[];
  cardsAccount: Card[];
  stripActionStatus = '';
  cActionStatus = '';
  rowIndex = -1;
  confirmation_btn = false;
  stripActionSuccessFail = '';
  stripActionCircle = '';
  stripCircleCheck = '';
  save_s_btn = false;
  save_a_btn = false;
  assign_card_btn = false;
  assignCardId: number = null;
  cardSeq: number = null;
  JSON = JSON;
  changedValue = false;
  originalChipLimit: number[] = [];
  chipOnly: boolean;

  constructor(
    private entitlementService: EntitlementService,
    private cardHolderService: CardholderService,
    private messageService: MessageService,
    private merchantService: MerchantService
  ) { }

  ngOnInit() {
    this.cardholder = CardholderService.retrieveCardholder();
    this.loadCardHolderDetails();
  }

  loadCardHolderDetails() {
    this.spinnerFlag = true;
    this.cardHolderService
      .getCardholderDetails(this.cardholder.payrollAccount)
      .subscribe(
        (data: CardholderDetails) => {
          this.cardSeq = data.cardList[0].cardSeq;
          //SVCDELIVER-29224- If card seq starts with 4 or 7 - for close loop cards and 
          // self enrolled cards that does not have an active card assigned
          //Visa forward tab should not display.
          if(this.isClosedLoopCard() || this.isSelfEnrolledCardholder()) {
            this.cardHolderService.isClosedLoopCard(true);
          }else{
            this.cardHolderService.isClosedLoopCard(false);
          }
          this.cardholderDetails = data;
          this.stripAccount = data.customerAccounts[0];
          this.chipsAccount = data.customerAccounts.slice(
            1,
            data.customerAccounts.length
          );
          this.identity = data.identity;
          this.isEscrow = data.escrow;
          this.customerAccount = data.customerAccounts[0]; // Payroll Account/Strip Account
          this.customerAccounts = data.customerAccounts;
          this.cardsAccount = data.cardList;

          this.cardsAccount.forEach((element: Card, idx: number) => {
            this.originalCardStatuses.push(element.status);
          });
          this.chipsAccount.forEach((element: CustomerAccount, idx: number) => {
            this.originalChipStatuses.push(element.status);
          });
          this.cardsAccount.forEach((element: Card, idx: number) => {
            this.originalChipLimit.push(element.chipLimit);
          });
          this.fixStatuses();
        },
        error => {
          this.messageService.error(
            'There was an error getting the card holder details ' + error.data
          );
        },
        () => {
          this.spinnerFlag = false;
          this.fixChipStatus();
          this.checkChipOnly();
          this.cardHolderService.chipDetails(this.chipOnly);
        }
      );
  }

  syncProfile() {
    this.merchantService.syncAccount(this.stripAccount).subscribe(
      () => {
        this.messageService.success('Sync Successful');
        this.loadCardHolderDetails();
      },
      () => {
        this.messageService.error('Sync Error');
      }
    );
  }

  showNewCardholder(newCardholder: ProfileSearchResult) {
    CardholderService.storeCardHolder(newCardholder);
    this.cardholder = newCardholder;
    this.loadCardHolderDetails();
  }

  onChangeCard(status: String, index: number) {
    if (status === this.originalCardStatuses[index]) {
      this.changedValue = false;
    } else {
      this.changedValue = true;
    }
  }

  onChangeChip(status: String, index: number){
    if (status === this.originalChipStatuses[index]) {
      this.changedValue = false;
    } else {
      this.changedValue = true;
    }
  }

  onChangeLimit(limit: number, index: number){
    if (limit == this.originalChipLimit[index]) {
      this.changedValue = false;
    } else {
      this.changedValue = true;
    }
  }

  hasEntitlements(entitlement) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  saveStripAccount() {
    const that = this;
    this.save_s_btn = true;

    this.spinnerFlag = true;
    this.cardHolderService
      .saveStripAccount(this.cardholder.payrollAccount, this.stripAccount)
      .subscribe(
        () => {
          this.messageService.success('Updated Successfully');
          that.loadCardHolderDetails();
          that.save_s_btn = false;
        },
        error => {
          if (error.status === NCConstants.HTTP_STATUS_INSUFFICIENT_STORAGE) {
            this.messageService.error(error.error);
          }
          that.save_s_btn = false;
        },
        () => {
          this.spinnerFlag = false;
        }
      );
  }

  saveAccounts(idx) {
    const postJSON = {
      card: this.cardsAccount[idx],
      customerAccount: this.chipsAccount[idx]
    };

    const that = this;
    this.save_a_btn = true;

    this.spinnerFlag = true;
    this.cardHolderService
      .saveChipCard(this.cardholder.payrollAccount, postJSON)
      .subscribe(
        () => {
          this.messageService.success('Updated Successfully');
          this.resetCardStatuses();
          this.fixChipStatus();
          that.loadCardHolderDetails();
          that.save_a_btn = false;
        },
        error => {
          if (error.status === NCConstants.HTTP_STATUS_INSUFFICIENT_STORAGE) {
            this.messageService.error(error.error);
          } else {
            this.messageService.error(
              'Error During Chip Card Save: ' + error.message
            );
          }
          that.save_a_btn = false;
        },
        () => {
          this.spinnerFlag = false;
          this.changedValue = false;
        }
      );
  }

  isSelfEnrolledCardholder() {
    return ('' + this.cardSeq).startsWith('7');
  }

  isClosedLoopCard() {
    return ('' + this.cardSeq).startsWith('4');
  }

  assignCard() {
    this.assign_card_btn = true;
    this.cardHolderService
      .assignCard(new AssignCard(this.cardSeq, this.assignCardId))
      .subscribe(
        () => {
          this.messageService.success('Card assigned successfully');
          this.loadCardHolderDetails();
          this.assign_card_btn = false;
        },
        () => {
          this.messageService.error('Card failed to assign');
          this.assign_card_btn = false;
        }
      );
  }

  fixChipStatus() {
    for(let i : number = 0; i < this.originalCardStatuses.length; i++)
    {
      if (this.originalCardStatuses[i] == 'ACTIVE')
      {
        continue;
      }
      if (this.originalCardStatuses[i] == 'STOLEN' || this.originalCardStatuses[i] == 'LOST' || this.originalCardStatuses[i] == 'DAMAGED' || this.originalCardStatuses[i] == 'CANCELLED') {
        this.chipsAccount[i].status = 'CLOSED';
        this.originalChipStatuses[i] = 'CLOSED';
      }
    }
  }

  fixStatuses() {
    if (this.originalCardStatuses.length > this.cardsAccount.length) {
      while (this.originalCardStatuses.length > this.cardsAccount.length) {
        this.originalCardStatuses.shift();
        this.originalChipStatuses.shift();
        this.originalChipLimit.shift();
      }
    }
  }

  resetCardStatuses() {
    for(let i : number = 0; i < this.originalCardStatuses.length; i++)
    {
      this.originalCardStatuses[i] = this.cardsAccount[i].status;
    }
  }

  isEMV(closedLoopPan) {
    return closedLoopPan != null;
  }

  checkChipOnly() {
    const index = this.cardsAccount.findIndex(x => x.type !== 'CHIP');
    this.chipOnly = index < 0;
  }
}
